(() => {
  const GALLERY_SELECTOR = 'media-gallery[data-desktop-layout="thumbnail_slider"]';
  const esc = (s) => (window.CSS && CSS.escape ? CSS.escape(String(s)) : String(s).replace(/[^a-zA-Z0-9_-]/g, "\\$&"));

  function initGallery(gallery) {
    if (gallery.__thumbArrowSyncAbort?.abort) gallery.__thumbArrowSyncAbort.abort();
    const controller = new AbortController();
    gallery.__thumbArrowSyncAbort = controller;
    const { signal } = controller;

    const viewerList = gallery.querySelector("ul.product__media-list");
    const thumbSlider = gallery.querySelector("slider-component.thumbnail-slider");
    if (!thumbSlider || !viewerList) return;

    const list = thumbSlider.querySelector("ul.thumbnail-list");
    const prevBtn = thumbSlider.querySelector("button.slider-button--prev");
    const nextBtn = thumbSlider.querySelector("button.slider-button--next");
    if (!list || !prevBtn || !nextBtn) return;

    const items = () => Array.from(list.querySelectorAll("li.thumbnail-list__item"));

    const getActiveMediaId = () =>
      viewerList.querySelector("li.product__media-item.is-active")?.dataset.mediaId ||
      viewerList.querySelector("li.product__media-item")?.dataset.mediaId ||
      null;

    const getActiveThumbLi = () => {
      const byAria = list.querySelector('button.thumbnail[aria-current="true"]')?.closest("li.thumbnail-list__item");
      if (byAria) return byAria;

      const activeMediaId = getActiveMediaId();
      if (!activeMediaId) return items()[0] || null;

      return list.querySelector(`li.thumbnail-list__item[data-target="${esc(activeMediaId)}"]`) || items()[0] || null;
    };

    const setDisabledByActive = () => {
      const its = items();
      const activeLi = getActiveThumbLi();
      const idx = activeLi ? its.indexOf(activeLi) : -1;

      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx === -1 || idx >= its.length - 1;
    };

    const go = (dir) => {
      const its = items();
      if (!its.length) return;

      const activeLi = getActiveThumbLi() || its[0];
      const idx = its.indexOf(activeLi);
      if (idx === -1) return;

      const nextIdx = dir === "next" ? idx + 1 : idx - 1;
      if (nextIdx < 0 || nextIdx >= its.length) return;

      const targetLi = its[nextIdx];
      const targetBtn = targetLi.querySelector("button.thumbnail");
      if (!targetBtn) return;

      targetBtn.click();

      targetLi.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

      requestAnimationFrame(setDisabledByActive);
    };

    const onArrowClick = (e) => {
      setDisabledByActive();
      if (e.currentTarget.disabled) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      const isPrev = e.currentTarget?.name === "previous";
      go(isPrev ? "prev" : "next");
    };

    prevBtn.addEventListener("click", onArrowClick, { signal, capture: true });
    nextBtn.addEventListener("click", onArrowClick, { signal, capture: true });

    const moAria = new MutationObserver(setDisabledByActive);
    moAria.observe(list, { subtree: true, attributes: true, attributeFilter: ["aria-current"] });

    const moViewer = new MutationObserver(() => {
      const activeMediaId = getActiveMediaId();
      if (activeMediaId) {
        const li = list.querySelector(`li.thumbnail-list__item[data-target="${esc(activeMediaId)}"]`);
        li?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
      setDisabledByActive();
    });
    moViewer.observe(viewerList, { subtree: true, attributes: true, attributeFilter: ["class"] });

    list.addEventListener("scroll", () => requestAnimationFrame(setDisabledByActive), {
      signal,
      passive: true,
    });
    window.addEventListener("resize", () => requestAnimationFrame(setDisabledByActive), { signal });

    signal.addEventListener(
      "abort",
      () => {
        moAria.disconnect();
        moViewer.disconnect();
      },
      { once: true },
    );

    setDisabledByActive();
  }

  function boot(root = document) {
    root.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
  }

  boot();

  document.addEventListener("shopify:section:load", (e) => boot(e.target));

  let variantTimer = null;
  const bootAfterVariant = () => {
    if (variantTimer) clearTimeout(variantTimer);
    variantTimer = setTimeout(() => boot(document), 250);
  };

  document.addEventListener("variant:change", bootAfterVariant);
  document.addEventListener("product:variant-change", bootAfterVariant);

  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (t && t.matches && t.matches('select[name="id"], input[name="id"]')) bootAfterVariant();
    },
    true,
  );
})();
